<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-4 w-4"
  >
    <path
      d="M1.9747 0.6394L0.6553 1.9496C0.2433 2.362 0.0163002 2.9106 0.0163002 3.4969C0.0163002 4.083 0.2433 4.6322 0.6553 5.0446L15.6024 19.9911L0.6387 34.9548C0.2267 35.3665 0 35.9157 0 36.5018C0 37.0878 0.2267 37.6374 0.6387 38.0494L1.9499 39.36C2.8026 40.2133 4.1916 40.2133 5.0443 39.36L22.9244 21.5439C23.3361 21.1322 23.6262 20.5836 23.6262 19.9924H23.6262C23.6262 19.3992 23.3358 18.8506 22.9244 18.4388L5.0927 0.6394C4.681 0.227 4.1158 0.0007 3.5298 0C2.9434 0 2.386 0.227 1.9747 0.6394Z"
      fill="currentColor"
    />
  </svg>
</template>
